'use client';
import { YEAR, MONTH, WEEK, DAY, HOUR, MINUTE, SECOND } from './constants.js';
import { toNumber } from './converters.js';
export { isAfter as isDateAfter, isBefore as isDateBefore, isEqual as isDateEqual } from 'date-fns';

var TimeUnit;
(function (TimeUnit) {
    TimeUnit["SECOND"] = "second";
    TimeUnit["MINUTE"] = "minute";
    TimeUnit["HOUR"] = "hour";
    TimeUnit["DAY"] = "day";
    TimeUnit["WEEK"] = "week";
    TimeUnit["MONTH"] = "month";
    TimeUnit["YEAR"] = "year";
})(TimeUnit || (TimeUnit = {}));
const timeUnitConversions = {
    [TimeUnit.SECOND]: SECOND,
    [TimeUnit.MINUTE]: MINUTE,
    [TimeUnit.HOUR]: HOUR,
    [TimeUnit.DAY]: DAY,
    [TimeUnit.WEEK]: WEEK,
    [TimeUnit.MONTH]: MONTH,
    [TimeUnit.YEAR]: YEAR,
};
/**
 * Get the time difference between two dates
 * @param earlierDate - The earlier date
 * @param laterDate - The later date
 * @param unit - The unit to use [default: undefined]
 * @returns The time difference
 */
const getTimeDifference = (earlierDate, laterDate, unit) => {
    const diff = toNumber(laterDate) - toNumber(earlierDate);
    return unit ? diff / timeUnitConversions[unit] : diff;
};

export { TimeUnit, getTimeDifference };
//# sourceMappingURL=comparators.js.map
